import Link from 'next/link'

export const Navbar = () => {
  return (
    <div className="navbar fr">
      <Link href="/" className="title tab">
        MoneyCoach
      </Link>
      <Link href="/videos" className="tab">
        Videos
      </Link>
      <Link href="/recommendations" className="tab">
        Products
      </Link>
      <Link href="/calculators" className="final tab">
        Calculators
      </Link>
    </div>
  )
}
